// Charge la base commune
import './common.js'

// charge bootstrap Scrollspy
import 'bootstrap/js/dist/scrollspy'

// Styles custom
import './scss/pages/programs.scss'

// Scripts librairies
import { dtectMap } from './js/libs/utils'

// Grounds Map
async function getProgramsMap ($f) {
  $f.load()
  import(/* webpackChunkName: "programsMap", webpackPrefetch: true */ './js/components/programsMap.js').then(() => {
    $f.load(false)
  })
}

// Grounds Map
async function getProgramsMapDetail ($f) {
  $f.load()
  import(/* webpackChunkName: "programsMapDetail", webpackPrefetch: true */ './js/components/programsMapDetail.js').then(() => {
    $f.load(false)
  })
}

// Real Estate Programs Search Form
async function getREPSForm ($f) {
  $f.load()
  import(/* webpackChunkName: "realEstateProgramsSearchForm", webpackPrefetch: true */ './js/components/realEstateProgramsSearchForm.js').then(() => {
    $f.load(false)
  })
}

// MagnificPopup
async function getMagnificPopup () {
  import(/* webpackChunkName: "magnificPopup" */ './js/components/magnificPopup.js')
}

// Contact Form
async function getContactForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm", webpackPreload: true */ './js/components/contactForm.js').then(() => {
    $f.load(false)
    /* global Waypoint */
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion du formulaire de recherche rapide des programmes
  const $e = $('.rep-search-form.in')
  if ($e.length) {
    $e.waypoint(function () {
      getREPSForm($e)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion image popup
  const $i = $('.image-popup-gallery, .image-popup-only')
  if ($i.length) {
    $i.waypoint(function () {
      getMagnificPopup()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $f = $('.contact-form')
  if ($f.length) {
    $f.waypoint(function () {
      getContactForm($f)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du multi menus sur mobile
  const $mn = $('#main-nav')
  const $h = $('#header')
  $h.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($h.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '999') } else { $mn.parents('.sticky-top').css('z-index', '1020') }
  })
  $mn.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($mn.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '1020') } else { $mn.parents('.sticky-top').css('z-index', '999') }
  })

  // ancre
  $mn.find('.scroll').each(function () {
    const $this = $(this)
    $this.off('click').on('click', function (e) {
      $mn.find('.navbar-close').trigger('click')
      const t = ($(e.target).is('a')) ? this.hash : $(this).attr('target')
      e.preventDefault()
      const h = $('#header').height()
      $('html,body').animate({ scrollTop: $(t).offset().top - h - 20 }, 500, function () {
        $('html,body').animate({ scrollTop: $(t).offset().top - h - 20 }, 300)
      })
      //      $('html, body').animate({ scrollTop: ($(t).offset().top) - -1 }, 1500)
    })
  })

  // wait until gmap is correctly loading
  dtectMap(function () {
    // gestion de la carte des programmes
    const $m = $('#programs-map')
    $m.waypoint(function () {
      if ($m.hasClass('detail')) {
        getProgramsMapDetail($m)
      } else {
        getProgramsMap($m)
      }
      this.destroy()
    }, {
      offset: '100%'
    })
  })
})
